<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div class="main">
      <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
        <template #end>
          <el-form-item class="endBtn">
            <!-- 导出按钮 -->
            <el-button type="primary" icon="el-icon-download"
              @click="Export(`油气费汇总表`)">导出</el-button>
            <!-- 导出图片按钮 -->
            <el-button :loading="btnloading" type="primary"
              @click="getExport">导出图片</el-button>
          </el-form-item>
        </template>
      </SearchField>

      <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" :btns="btns" :page="page"
        :limit="limit" :total="total" :showIndex="true" :showTotal="true" :getTotal="getTotal"
        @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
        <template slot="photo" slot-scope="params">
          <!-- <img v-if="params.params.photo && params.params.photo[0]" :src="params.params.photo[0].url"> -->
          <el-image v-if="params.params.photo && params.params.photo[0]" :src="params.params.photo[0].url"
            :preview-src-list="params.params.urls"></el-image>
          <span v-if="!params.params.photo || !params.params.photo[0]">-</span>
        </template>
        <template slot="moneyphoto" slot-scope="params">
          <!-- <img v-if="params.params.moneyphoto && params.params.moneyphoto[0]" :src="params.params.moneyphoto[0].url"> -->
          <el-image v-if="params.params.moneyphoto && params.params.moneyphoto[0]"
            :src="params.params.moneyphoto[0].url" :preview-src-list="params.params.urls"></el-image>
          <span v-if="!params.params.moneyphoto || !params.params.moneyphoto[0]">-</span>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import tableMixin from "../../mixin/table";

export default {
  name: "FinanceOilFee",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'oil',
      breadcrumb: [
        { name: "财务管理" },
        { name: "油气费汇总表" },
      ],
      menuIndex: '',
      menu: [],
      sformInline: { month: '' },
      formCtrl: [
        {
          ...this.ctrls.fleet,
          options: [],
        },
        {
          ...this.ctrls.month,
        },
        {
          ...this.ctrls.license,
          label: '车牌号',
        },
      ],
      cols: [
        { prop: "license", label: "车牌号", width: "100" },
        { prop: "edittime", label: "日期" },
        { prop: "order_num", label: "订单编号", width: 150 },
        { prop: "doil", label: "现金金额", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "moneyphoto", label: "现金票据", slot: 'moneyphoto' },
        { prop: "moneydoil", label: "划卡金额", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "photo", label: "划卡票据", slot: 'photo' },
        { prop: "total", label: "合计", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      getTotalProperty: ['doil', 'moneydoil', 'total'],
      btns: [
        {
          ...this.editBtn,
          cb: ({ orderid }) => {
            this.$router.push(
              `/finance/oilfeedetails?id=${orderid}&mode=edit`
            );
          },
        },
      ],
      baseParams: ['gid', 'month'],
      tabData: [],
      btnloading: false,
    };
  },
  computed: {
    ...mapState([
      'store',
    ]),
  },
  methods: {
    ...mapMutations([
      'setState',
    ]),
    getExport() {
      this.btnloading = true
      let url = `/oil/expicture`;
      const params = {
        // userid: this.user.id,
        month: this.formInline.month,
      }
      this.post(url, params, (res) => {
        const { msg, url } = res
        if (msg === 'success' && url) {
          // console.log(res)
          var link = document.createElement('a')
          link.href = url
          link.click()
        } else {
          this.$message({
            type: 'error',
            message: msg || '导出失败，请稍后再试！',
          });
        }
        this.btnloading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    tableDataHandler(res) {
      if (typeof res === 'string') {
        this.$message({
          type: 'error',
          message: res
        });
      } else {
        const { count, data } = res
        this.total = count
        if (data && data.length) {
          this.tableData = data.map(v => {
            const obj = this.dataObjHandler(v)
            obj.urls = []
            // console.log({ ...obj })
            obj.photo && obj.photo.map(o => {
              obj.urls.push(o.url)
            })
            obj.moneyphoto && obj.moneyphoto.map(o => {
              obj.urls.push(o.url)
            })
            return obj
          })
        }
      }
    },
    getTabData() {
      this.loading = true
      this.tabData = [];
      let url = `${this.baseUrl}/index`;
      const params = {
        // userid: this.user.id,
      }
      // console.log(url, params)
      this.post(url, params, ({ gasstation, team }) => {
        this.loading = false
        if (gasstation && gasstation.length) {
          this.tabData = gasstation

          this.menu = gasstation.map((c, i) => {
            return {
              name: c.gasname,
              path: `/finance/oilFee/table/${i + 1}`,
            }
          })

          this.menuIndex = `${this.$route.path}`
          this.setState({
            key: 'gasstation',
            value: gasstation,
          })
          // this.setTabData({ gasstation, month })
        }

        this.formCtrl.map(v => {
          if (v.keyName == 'fleet' && team && team.length) {
            v.options = team.map(o => {
              return {
                label: o.nickname,
                value: o.id,
              }
            })
          }
        })

        this.setParams();
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setParams() {
      const { idx } = this.$route.params
      console.log(this.tabData)
      if (this.tabData && this.tabData.length) {
        this.formInline.gid = this.tabData[idx - 1].id
        // this.cols[4].label = this.tabData[idx - 1].gasname
        this.$nextTick(this.getList);
      }
    },
  },
  watch: {
    $route() {
      this.setParams()
    },
  },
  created() {
    this.MONTH = this.CURR_MONTH
    this.$set(this.formInline, 'month', this.CURR_MONTH)
  },
  mounted() {
    const { user_group_id, id } = this.user
    if (user_group_id != 1 || id != 1) {
      this.btns[0] = {
        ...this.viewBtn,
        cb: ({ orderid }) => {
          this.$router.push(
            `/finance/oilfeedetails?id=${orderid}&mode=view`
          );
        },
      }
    }
    this.getTabData()
  },
};
</script>

<style lang="less" scoped>
.main {
  /deep/ .el-table {
    .el-table__cell {
      .el-image {
        width: 90px;
        height: 90px;
      }
    }
  }
}
</style>
